// constants
// Purpose: Defines the constants module and the local helpers/components used in this file.
// Scope: Keeps behavior unchanged while isolating this concern into a clear, single-responsibility unit.
export const ROTATE_MS = 20000;
export const HARD_REFRESH_MS = 1 * 60 * 60 * 1000;
